import React, { useCallback, useEffect, useState } from 'react'
import StepperCustom from '../../../components/step/Stepper'
import { routeName } from '../../../routes/routeName'
import NavigateListCustom from '../../../components/navigation/NavigationListCustom'
import ContainerLayout from '../../../components/container-layout/ContainerLayout'
import { useTranslation } from 'react-i18next'
import { NavigateFunction, useNavigate, useParams } from 'react-router-dom'
import { Box, useMediaQuery, useTheme } from '@mui/material'
import StateComponents from '../../../components/state-component/StateComponents'
import ContainerButton from '../../../components/button/ContainerButton'
import TableCustom from '../../../components/table/tableCustom'
import { debouncedApiCall, handleTypingNumber } from '../../../utils/app.utils'
import TableRowCommon from '../../../components/table/TableRowCommon'
import OptionsButtonCustom from '../../../components/button/OptionsButtonCustom'
import moment from 'moment'
import { alertActive, alertError, alertSuccess } from '../../../components/alert/swal'
import { PeriodExaminationApi } from '../../../api/period_examination/period_examination.api'
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice'
import { useDispatch } from 'react-redux'
import { ExaminationApi } from '../../../api/examination-master/examination-master.api'
import ModalCustom from '../../../components/modal/ModalCustom'
import { AdmissionAdminApi } from '../../../api/admission_admin/admission_admin.api'
import _ from 'lodash'
import { degreeApi } from '../../../api/degree/degree.api'
import { facultyApi } from '../../../api/factulty/factulty.api'
import StatusCustom from '../../../components/status/statusCustom'

export default function PeriodExaminationDetail() {
    const { t } = useTranslation();
    const navigate: NavigateFunction = useNavigate();
    const { id } = useParams()

    const dispatch = useDispatch();
    const [tabStep, setTebStep] = useState(0);
    const [examinationList, setExaminationList] = useState<any[]>([]);
    const [form, setForm] = useState<any>({
        student_list: [
            // {
            //     id_admission_student: 33
            // }
        ]
    });

    const allStep = [
        {
            name: t("PERIOD_EXAMINATION_ENTER_INFO"),
            isAccept: false,
            icon: null
        },
        {
            name: t("PERIOD_EXAMINATION_ENTER_EXAMINEE_INFO"),
            isAccept: false,
            icon: null
        },

    ];

    const getExaminationList = async () => {
        let query: any = {
            page: 1,
            limit: 10
        }
        // if (startDate) query = { ...query, start_date: moment(startDate).format("YYYY-MM-DD") }
        // if (endDate) query = { ...query, end_date: moment(endDate).format("YYYY-MM-DD") }
        await ExaminationApi.getExaminationList(query).then((res) => {
            if (res.status < 300) {
                setExaminationList(res.data?.data?.items || []);
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
        })
    }
    useEffect(() => {
        getExaminationList()
    }, [])

    const handleSubmit = async () => {
        if (!form?.period_examination_name) {
            return alertError(t('PERIOD_EXAMINATION_ENTER_NAME'))
        }
        if (!form?.period_examination_start_date) {
            return alertError(t('PERIOD_EXAMINATION_ENTER_DATE'))
        }
        if (!form?.period_examination_start_time) {
            return alertError(t('PERIOD_EXAMINATION_ENTER_START_TIME'))
        }
        if (!form?.period_examination_end_time) {
            return alertError(t('PERIOD_EXAMINATION_ENTER_END_TIME'))
        }
        if (!form?.id_examination) {
            return alertError(t('PERIOD_EXAMINATION_ENTER_EXAMINEE'))
        }
        if (!form?.period_examination_pass) {
            return alertError(t('PERIOD_EXAMINATION_ENTER_PASS_SCORE'))
        }
        const body = {
            ...form,
        }
        if (id) {
            await PeriodExaminationApi.updatePeriodExamination(+id, body)
                .then((res) => {
                    if (res.status < 300) {
                        alertSuccess(t("PERIOD_EXAMINATION_SAVE"), t("PERIOD_EXAMINATION_SAVE_SUCCESS"), undefined, () => {
                            navigate(routeName.admission.period_examination)
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                    alertError(t("PERIOD_EXAMINATION_SAVE"), t("PERIOD_EXAMINATION_SAVE_FAILED"));
                })
                .finally(() => {
                    dispatch(unsetLoading());
                });
        } else {
            await PeriodExaminationApi.createPeriodExamination(body)
                .then((res) => {
                    if (res.status < 300) {
                        alertSuccess(t("PERIOD_EXAMINATION_SAVE"), t("PERIOD_EXAMINATION_SAVE_SUCCESS"), undefined, () => {
                            navigate(routeName.admission.period_examination)
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                    alertError(t("PERIOD_EXAMINATION_SAVE"), t("PERIOD_EXAMINATION_SAVE_FAILED"));
                })
                .finally(() => {
                    dispatch(unsetLoading());
                })
        }

    }


    const getDetail = async () => {
        dispatch(setLoading());

        await PeriodExaminationApi.getPeriodExaminationById(id).then((res) => {
            if (res.status < 300) {
                setForm(res.data.data)
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }
    useEffect(() => {
        if (id) {
            getDetail()
        }
    }, [])

    const handleAutoScore = async () => {
        await PeriodExaminationApi.autoScore(id)
            .then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("PERIOD_EXAMINATION_CALCULATE_OBJECTIVE_SCORE"), t("PERIOD_EXAMINATION_CALCULATE_OBJECTIVE_SCORE_SUCCESS"));
                    getDetail()
                    // navigate(routeName.admission.AdmissionFormUpdte?.replace(':id', res.data.data?.id_admission_student))
                }
            })
            .catch((err) => {
                console.log(err);
                alertError(t("PERIOD_EXAMINATION_CALCULATE_OBJECTIVE_SCORE"), t("PERIOD_EXAMINATION_CALCULATE_OBJECTIVE_SCORE_FAILED"));
            })
            .finally(() => {
                dispatch(unsetLoading());
            });
    }
    const handleConfirmScore = async () => {
        await PeriodExaminationApi.confirmScore(id)
            .then((res) => {
                if (res.status < 300) {
                    getDetail()
                    alertSuccess(t("PERIOD_EXAMINATION_CONFIRM_REVIEW"), t("PERIOD_EXAMINATION_CONFIRM_REVIEW_SUCCESS"), undefined, () => {
                        navigate(routeName.admission.period_examination)
                    });
                    
                }
            })
            .catch((err) => {
                console.log(err);
                alertError(t("PERIOD_EXAMINATION_CONFIRM_REVIEW"), t("PERIOD_EXAMINATION_CONFIRM_REVIEW_FAILED"));
            })
            .finally(() => {
                dispatch(unsetLoading());
            });
    }

    return (
        <div className='w-full'>
            <ContainerLayout
                title={!id ? t('PERIOD_EXAMINATION_ADD') : t("PERIOD_EXAMINATION_INFO")}
                // hidden_sub_title
                navigateContent={
                    <NavigateListCustom
                        navigateData={[
                            {
                                key: "complaintSubmit",
                                name: t("PERIOD_EXAMINATION_ADMISSION"),
                                disabled_match: true,
                                pathName: routeName.admission.period_examination
                            },
                            {
                                key: "complaintSubmit",
                                name: t("PERIOD_EXAMINATION"),
                                pathName: routeName.admission.period_examination
                            },
                            {
                                key: "complaintSubmit",
                                name: !id ?  t("PERIOD_EXAMINATION_ADD") : t("PERIOD_EXAMINATION_INFO"),
                                pathName: routeName.admission.period_examination_add
                            },
                        ]}
                    />
                }

                content={
                    <div className='w-full'>
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: 'center',
                                marginTop: "24px",
                                '& > div': {
                                    width: "100%"
                                }
                            }}
                        >
                            <StepperCustom
                                sx={{ maxWidth: "400px" }}
                                step={tabStep}
                                setStep={setTebStep}
                                stepLabel={allStep}
                            // view={true}
                            />
                        </Box>
                        {tabStep === 0 && <StateComponents
                            otherProps={{ spacing: 2 }}
                            typeProps={[

                                {
                                    seq: 1,
                                    type: "TEXT_FIELD",
                                    gridProps: {
                                        xs: 12,
                                        md: 6
                                    },
                                    fieldProps: {
                                        heading: t("PERIOD_EXAMINATION_NAME"),
                                        onChange: (e) => {
                                            setForm({ ...form, period_examination_name: e.target.value })
                                        },
                                        value: form?.period_examination_name,
                                        disabled: id ? form?.period_examination_status !== 'WAIT' : false
                                    }
                                },
                                {
                                    seq: 2,
                                    type: "DATE",
                                    gridProps: {
                                        xs: 12,
                                        md: 3
                                    },
                                    fieldProps: {
                                        onChange: (e) => {
                                            setForm({ ...form, period_examination_start_date: moment(e).format('YYYY-MM-DD') })

                                        },
                                        heading: t('PERIOD_EXAMINATION_EXAM_DATE'),
                                        placeholder: t('PERIOD_EXAMINATION_EXAM_DATE'),
                                        allowClear: true,
                                        onClear: () => {
                                            setForm({ ...form, period_examination_start_date: '' })

                                        },
                                        value: form?.period_examination_start_date,
                                        disabled: id ? form?.period_examination_status !== 'WAIT' : false
                                    }
                                },
                                {
                                    seq: 3,
                                    type: "TEXT_FIELD",
                                    gridProps: {
                                        xs: 12,
                                        md: 1.5
                                    },
                                    fieldProps: {
                                        heading: t("PERIOD_EXAMINATION_START_TIME"),
                                        onChange: (e) => {
                                            setForm({ ...form, period_examination_start_time: e.target.value })
                                        },
                                        value: form?.period_examination_start_time,
                                        type: "time",
                                        disabled: id ? form?.period_examination_status !== 'WAIT' : false
                                    }
                                },
                                {
                                    seq: 4,
                                    type: "TEXT_FIELD",
                                    gridProps: {
                                        xs: 12,
                                        md: 1.5
                                    },
                                    fieldProps: {
                                        heading: t("PERIOD_EXAMINATION_END_TIME"),
                                        onChange: (e) => {
                                            setForm({ ...form, period_examination_end_time: e.target.value })
                                        },
                                        value: form?.period_examination_end_time,
                                        type: "time",
                                        disabled: id ? form?.period_examination_status !== 'WAIT' : false
                                    }
                                },
                                {
                                    seq: 5,
                                    type: "SELECT",
                                    gridProps: {
                                        xs: 12,
                                        md: 4
                                    },
                                    fieldProps: {
                                        labelId: "ss",
                                        heading: t("PERIOD_EXAMINATION_EXAM"),
                                        onChange: (e) => {
                                            setForm({ ...form, id_examination: e.target.value, examination_name: examinationList?.find((item: any) => item.id_examination === e.target.value)?.examination_name })
                                        },
                                        value: form?.id_examination || '',
                                        options: examinationList?.map((item: any) => {
                                            return {
                                                label: item?.examination_name,
                                                value: item?.id_examination
                                            }
                                        }),
                                        selectId: "",
                                        disabled: id ? form?.period_examination_status !== 'WAIT' : false
                                    }
                                },
                                {
                                    seq: 6,
                                    type: "TEXT_FIELD",
                                    gridProps: {
                                        xs: 12,
                                        md: 2
                                    },
                                    fieldProps: {
                                        heading: t("PERIOD_EXAMINATION_EXAM_TYPE"),
                                        onChange: (e) => {
                                            // setForm({ ...form, period_examination_end_time: e.target.value })
                                        },
                                        value: examinationList?.find((item: any) => item.id_examination === form?.id_examination)?.examination_types || '',
                                        disabled: true
                                    }
                                },
                                {
                                    seq: 7,
                                    type: "TEXT_FIELD",
                                    gridProps: {
                                        xs: 12,
                                        md: 2
                                    },
                                    fieldProps: {
                                        heading: t("PERIOD_EXAMINATION_TOTAL_QUESTIONS"),
                                        onChange: (e) => { },
                                        value: examinationList?.find((item: any) => item.id_examination === form?.id_examination)?.total_detail || '',
                                        disabled: true
                                    }
                                },
                                {
                                    seq: 8,
                                    type: "TEXT_FIELD",
                                    gridProps: {
                                        xs: 12,
                                        md: 2
                                    },
                                    fieldProps: {
                                        heading: t("PERIOD_EXAMINATION_TOTAL_SCORE"),
                                        onChange: (e) => {
                                            // setForm({ ...form, period_examination_end_time: e.target.value })
                                        },
                                        value: examinationList?.find((item: any) => item.id_examination === form?.id_examination)?.total_score || '',
                                        disabled: true
                                    }
                                },
                                {
                                    seq: 9,
                                    type: "TEXT_FIELD",
                                    gridProps: {
                                        xs: 12,
                                        md: 2
                                    },
                                    fieldProps: {
                                        heading: t("PERIOD_EXAMINATION_PASS_SCORE"),
                                        onChange: (e) => {
                                            setForm({ ...form, period_examination_pass: e.target.value })
                                        },
                                        value: form?.period_examination_pass,
                                        onkeypress: handleTypingNumber,
                                        disabled: id ? form?.period_examination_status !== 'WAIT' : false
                                    }
                                },
                            ]} />}
                        {tabStep === 1 && <>
                            <ListApplicants period_examination_status={form?.period_examination_status} student_list={form?.student_list} form={form} setForm={setForm} />
                        </>}
                        <ContainerButton
                            sxContainer={{ my: 3 }}
                            buttonData={[
                                {
                                    seq: 1,
                                    buttonProps: {
                                        onClick: () => { navigate(routeName.admission.period_examination) },
                                    },
                                    key: "CANCEL",
                                    label: t("PERIOD_EXAMINATION_BACK"),
                                    type: "CANCEL"
                                },
                                {
                                    seq: 2,
                                    buttonProps: {
                                        onClick: () => {
                                            setTebStep(1)
                                        }
                                    },
                                    hidden: tabStep !== 0,
                                    key: "SEND",
                                    label: t("PERIOD_EXAMINATION_NEXT"),
                                    type: 'SEND'
                                },
                                {
                                    seq: 2,
                                    buttonProps: {
                                        onClick: () => {
                                            handleSubmit()
                                        }
                                    },
                                    hidden: tabStep === 0 || id ? form?.period_examination_status !== 'WAIT' : false,
                                    key: "NONE",
                                    label: t("PERIOD_EXAMINATION_CONFIRM"),
                                    type: 'NONE'
                                },
                                {
                                    seq: 2,
                                    buttonProps: {
                                        onClick: () => {
                                            handleAutoScore()
                                        }
                                    },
                                    hidden: tabStep === 0 || form?.period_examination_status !== 'CLOSE',
                                    key: "SAVE_DRAFT",
                                    label: t("PERIOD_EXAMINATION_CONFIRM"),
                                    type: "SAVE_DRAFT"
                                },
                                {
                                    seq: 3,
                                    buttonProps: {
                                        onClick: () => {
                                            alertActive(t("PERIOD_EXAMINATION_CONFIRM_REVIEW"), t("PERIOD_EXAMINATION_CONFIRM_REVIEW_ASK"), undefined, undefined, async () => {
                                                handleConfirmScore()
                                            })
                                        }
                                    },
                                    hidden: tabStep === 0 || form?.period_examination_status !== 'CLOSE',
                                    key: "NONE",
                                    label: t("PERIOD_EXAMINATION_CONFIRM_REVIEW"),
                                    type: 'NONE'
                                },

                            ]}
                        />
                    </div>
                }
            />
        </div>
    )
}

const ListApplicants = (props: any) => {
    const { period_examination_status, student_list, form, setForm } = props
    const { t } = useTranslation();
    const { id } = useParams()
    const theme = useTheme()

    const dispatch = useDispatch();
    const matches = useMediaQuery(theme.breakpoints.up("md"));
    const navigate: NavigateFunction = useNavigate();
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("modified_date");
    const [sortType, setSortType] = useState<string>("DESC")
    const [keyword, setKeyword] = useState<string>("");
    const [data, setData] = useState<any[]>([]);
    const [showModal, setShowModal] = useState<string>("");

    // const [startDate, setStartDate] = useState<string>("");
    // const [endDate, setEndDate] = useState<string>("");
    // const [date_range, set_date_range] = useState<string[]>([]);


    const handleCloseModal = () => {
        setShowModal("")
        setData([]);
        // setForm({})
    }
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    const headCells = [
        {
            id: "id_comment", width: 300, sortable: false, disablePadding: false, align: 'left', label: t("PERIOD_EXAMINATION_FULL_NAME")
        },
        {
            id: "subject_name", disablePadding: false, width: 200, align: "center", label: t("PERIOD_EXAMINATION_NICKNAME")
        },

        {
            id: "detail", disablePadding: false, align: "center", width: 200, label: t("PERIOD_EXAMINATION_LEVEL")
        },
        {
            id: "detail", disablePadding: false, align: "center", width: 200, label: t("PERIOD_EXAMINATION_COURSE")
        },
        // {
        //     id: "detail", disablePadding: false, align: "center", width: 100, label: t("จำนวนข้อ")
        // },
        {
            id: "detail", disablePadding: false, align: "center", width: 150, label: t("PERIOD_EXAMINATION_SCORE_OBTAINED")
        },
        {
            id: "detail", disablePadding: false, align: "center", width: 250, label: t("PERIOD_EXAMINATION_STATUS")
        },

        {
            id: "action", disablePadding: false, align: "left", padding: "0 8px", width: 180, class: matches && data.length > 0, label: ""
        },
    ];
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            middle_name,
            student_point,
            first_name,
            last_name,
            degree_name,
            faculty_name,
            id_period_examination_student,
            id_admission_student,
            no_point_count
        } =
            objData;
        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "left", label: `${first_name} ${last_name}` || "-" },
                {
                    option: "TEXT",
                    align: "center",
                    label: middle_name || "-",
                },

                {
                    option: "TEXT",
                    align: "center",
                    label: degree_name || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: faculty_name || "-",
                },
                // {
                //     option: "TEXT",
                //     align: "center",
                //     label: "-",
                // },
                {
                    option: "TEXT",
                    align: "center",
                    label: student_point || "-",
                },

                {
                    option: "COMPONENT",
                    align: "center",
                    component: id ? <StatusCustom
                        disableMaxWidth
                        text={t(no_point_count >= form?.examination_detail_count ? 'ยังไม่ได้ตรวจ / รอตรวจ' : no_point_count <= 0 ? 'ตรวจเสร็จแล้ว' : "ตรวจไปบางส่วน")}
                        type={/* i18n-ignore */ no_point_count >= form?.examination_detail_count ? 'ยังไม่ได้ตรวจ / รอตรวจ' : no_point_count <= 0 ? 'ตรวจเสร็จแล้ว' : "ตรวจไปบางส่วน"}
                    /> : '-',
                },

                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches && data.length > 0,
                    component: <div className='flex justify-center items-center'>
                        {/* <IconButton onClick={() => navigate(routeName.admission.applicants_detail)}>
                            <ArrowForwardIosIcon />
                        </IconButton> */}
                        <OptionsButtonCustom
                            enableEdit={period_examination_status === 'CLOSE'}
                            enableView
                            // enableDelete={period_examination_status !== 'CLOSE' || period_examination_status !== 'OPEN' || period_examination_status !== 'CONFIRM'}
                            enableDelete={id ? period_examination_status === 'WAIT' ? true : false : true}
                            onViewClick={() => id ? id_period_examination_student ? navigate(routeName.admission.admission_exam_view?.replace(':id', `${id}`)?.replace(':id_period_examination_student', `${id_period_examination_student}`)?.replace(':id_admission_student', `${id_admission_student}`)) : navigate(routeName.admission.applicants_detail.replace(':id', id_admission_student)) : navigate(routeName.admission.applicants_detail.replace(':id', id_admission_student))}
                            onEditClick={() => window.open(routeName.admission.admission_exam_detail?.replace(':id', `${id}`)?.replace(':id_period_examination_student', `${id_period_examination_student}`)?.replace(':id_admission_student', `${id_admission_student}`), '_blank')}
                            onDeleteClick={() => id ? handleDeleteList(id_admission_student) : setForm({ ...form, student_list: student_list?.filter((item: any) => id_admission_student !== item?.id_admission_student) })}
                        />
                    </div>
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

    const handleDeleteList = (id_admission_student: number) => {
        alertActive(t("PERIOD_EXAMINATION_DELETE_EXAMINEE"), t("PERIOD_EXAMINATION_DELETE_EXAMINEE_ASK"), undefined, undefined, async () => {
            dispatch(setLoading());
            await PeriodExaminationApi.deleteAdmissionStudent(Number(id), id_admission_student).then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("PERIOD_EXAMINATION_DELETE_EXAMINEE"), t("PERIOD_EXAMINATION_DELETE_EXAMINEE_SUCCESS"))
                    setForm({ ...form, student_list: student_list?.filter((item: any) => id_admission_student !== item?.id_admission_student) })
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("PERIOD_EXAMINATION_DELETE_EXAMINEE"), t("PERIOD_EXAMINATION_DELETE_EXAMINEE_FAILED"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        })
    }


    return (
        <>
            <div className='w-full'>

                <StateComponents
                    otherProps={{ spacing: 2 }}
                    typeProps={[
                        // {
                        //     seq: 1,
                        //     type: "TEXT_FIELD",
                        //     gridProps: {
                        //         xs: 12,
                        //         md: 4
                        //     },
                        //     fieldProps: {
                        //         placeholder: "ค้นหาชื่อรอบการสอบ",
                        //         onChange: (e) => debouncedApiCall({ setItem: setKeyword, searchItem: e.target.value })
                        //     }
                        // },

                        {
                            type: "COMPONENT",
                            seq: 1,
                            fieldProps: {
                                element: <></>
                            },
                            gridProps: {
                                xs: 12,
                                md: 9
                            }
                        },

                        {
                            seq: 2,
                            type: "BUTTON",
                            gridProps: {
                                xs: 6,
                                md: 3
                            },
                            fieldProps: {
                                justifyContent: "flex-end",
                                buttonData: [
                                    {
                                        seq: 1,
                                        key: "ADD2",
                                        label: t("PERIOD_EXAMINATION_ADD_EXAMINEE"),
                                        buttonProps: {
                                            onClick: () => {
                                                // navigate(routeName.admission.period_examination_add)
                                                setShowModal('ADD')
                                            },
                                        },
                                        hidden: id ? period_examination_status !== 'WAIT' : false,
                                        type: "ADD2"
                                    }
                                ]
                            }
                        }
                    ]}
                />

                <section className='w-full mt-4'>
                    <TableCustom
                        tableMinWidth={1440}
                        tableFixedWidth
                        customScroll
                        page={page}
                        pageLimit={pageLimit}
                        sortBy={sortBy}
                        sortType={sortType}
                        headCells={headCells}
                        rowCount={student_list.length}
                        rowsData={student_list?.map((data: any, i: any) => {
                            return renderData(data, i)
                        })}
                        onSort={handleRequestSort}
                        setPageLimit={(value: number) => setPageLimit(value)}
                        setPage={(value: number) => setPage(value)}
                    />
                </section>
            </div>
            {showModal !== '' && (
                <ModalCustom
                    open
                    title={t('PERIOD_EXAMINATION_ADD_EXAMINEE')}
                    subTitle={t("PERIOD_EXAMINATION_COMPLETE_DATA_REQUIRED")}
                    maxWidth={1600}
                    onClose={handleCloseModal}
                    containerButton={{
                        // disabled_submit: !form.gallery_type_name,
                        hidden_submit: showModal === 'VIEW',
                        onClose: handleCloseModal,
                        onSubmit: () => {
                            setForm({ ...form, student_list: [...student_list, ...data] })
                            handleCloseModal()
                        }
                    }}
                    component={
                        <div className='w-full'>
                            <SelectAdmission data={data} setData={setData} />
                        </div>
                    }
                />
            )}
        </>
    )
}
const SelectAdmission = (props: any) => {
    const { data, setData } = props
    const { t, i18n } = useTranslation();
    const theme = useTheme()
    const dispatch = useDispatch();

    const matches = useMediaQuery(theme.breakpoints.up("md"));
    const navigate: NavigateFunction = useNavigate();
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("modified_date");
    const [sortType, setSortType] = useState<string>("DESC")
    const [keyword, setKeyword] = useState<string>("");
    const [item, setItem] = useState<any[]>([]);
    const [isChecks, setIsChecks] = useState<any[]>([]);
    const [isCheckAll, setIsCheckAll] = useState<string>("");
    const [degree, setDegree] = useState<any[]>([]);
    const [faculty, setFaculty] = useState<any[]>([]);
    const [id_degree, set_id_degree] = useState<any>("ALL");
    const [id_faculty, set_id_faculty] = useState<any>("ALL");

    const onCheck = (event: any) => {
        const { checked, value } = event;
        if (checked) {
            setIsChecks((prev) => [...prev, Number(value)]);
            setData((prev: any) => [...prev, item?.find((item: any) => item?.id_admission_student === Number(value))])
        } else {
            setIsChecks((prev) => prev.filter((x) => x !== Number(value)));
            setData((prev: any) => prev.filter((x: any) => x?.id_admission_student !== Number(value)))

        }
    };

    const onCheckAll = (event: any) => {
        const { checked } = event;
        const id = item?.map(
            (filteredItem: { id_admission_student: number }) => filteredItem?.id_admission_student
        );
        if (checked) {
            setIsChecks(Array.from(new Set([...isChecks, ...id])));
            setData(Array.from(new Set([...data, ...item])))

        } else {
            setIsChecks([]);
            setData([])

            // setIsChecks(_.filter(isChecks, (i) => !_.includes(id, i)));
        }
    };
    const handleOnCheckAll = () => {
        const hasSome = _.some(item, (i: any) =>
            _.some(isChecks, (j: number) => Number(i?.id_admission_student) === Number(j))
        );
        const hasAll = _.every(item, (i: any) =>
            _.some(isChecks, (j: number) => Number(i?.id_admission_student) === Number(j))
        );
        if (!_.isEmpty(isChecks) && !hasAll && hasSome)
            setIsCheckAll("indeterminate");
        else if (!_.isEmpty(isChecks) && hasAll) setIsCheckAll("checked");
        else setIsCheckAll("");
    };
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    useEffect(() => {
        handleOnCheckAll();
    }, [isChecks]);

    const headCells = [
        {
            id: "id_admission_student",
            disablePadding: false,
            label: "CHECKBOX",
            align: "end",
            // disabled: view
            values: [],
            indeterminate: isCheckAll === "indeterminate" && true,
            checked: isCheckAll === "checked" && true,
            disableDropdown: true,
            hiddenDropdown: true,
            onCheckAll: (event: any) => onCheckAll(event.target),
            width: 50,
            sortable: false,
        },
        {
            id: "id_comment", width: 300, sortable: false, disablePadding: false, align: 'left', label: t("PERIOD_EXAMINATION_FULL_NAME")
        },
        {
            id: "subject_name", disablePadding: false, width: 300, align: "center", label: t("PERIOD_EXAMINATION_NICKNAME")
        },

        {
            id: "detail", disablePadding: false, align: "center", width: 300, label: t("PERIOD_EXAMINATION_LEVEL")
        },
        {
            id: "detail", disablePadding: false, align: "center", width: 300, label: t("PERIOD_EXAMINATION_COURSE")
        },

        {
            id: "action", disablePadding: false, align: "left", padding: "0 8px", width: 80, class: matches && item.length > 0, label: ""
        },
    ];
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            middle_name,
            degree_name,
            faculty_name,
            first_name,
            last_name,
            id_admission_student
        } = objData;
        const rowCheck = _.some(
            isChecks,
            (i: number) => Number(i) === Number(id_admission_student)
        );
        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            rowSelect: rowCheck,
            columns: [
                {
                    option: "CHECKBOX",
                    align: "center",
                    label: id_admission_student,
                    // disabled: service_ticket_status !== WORKODER_STATUS.WORKCLOSE
                },
                { option: "TEXT", align: "left", label: `${first_name} ${last_name}` || "-" },
                {
                    option: "TEXT",
                    align: "center",
                    label: middle_name || "-",
                },

                {
                    option: "TEXT",
                    align: "center",
                    label: degree_name || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: faculty_name || "-",
                },

                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches && data.length > 0,
                    component: <div className='flex justify-center items-center'>
                        {/* <IconButton onClick={() => navigate(routeName.admission.applicants_detail)}>
                            <ArrowForwardIosIcon />
                        </IconButton> */}
                        <OptionsButtonCustom
                            // enableEdit
                            enableView
                            onViewClick={() => navigate(routeName.admission.applicants_detail.replace(':id', id_admission_student))}
                        // onEditClick={() => handleGetOneDetail(id_comment, 'EDIT')}
                        // onDeleteClick={() => handleDeleteList(id_comment)}
                        />
                    </div>
                },
            ],
        };



        return <TableRowCommon
            {...objRenderData}
            onCheck={(event) => onCheck(event.target)}

        />;

    };

    const handleGetData = useCallback(async () => {
        let query: any = {
            page: page,
            limit: pageLimit
        }
        if (keyword) query = { ...query, search: keyword }
        if (id_degree !== 'ALL') query = { ...query, id_degree: id_degree }
        if (id_faculty !== "ALL") query = { ...query, id_faculty: id_faculty }
        // if (startDate) query = { ...query, start_date: moment(startDate).format("YYYY-MM-DD") }
        // if (endDate) query = { ...query, end_date: moment(endDate).format("YYYY-MM-DD") }
        dispatch(setLoading());
        await AdmissionAdminApi.verified_list(query).then((res) => {
            if (res.status < 300) {
                setItem(res.data?.data?.items || []);
                setTotalItems(res.data?.data?.meta?.totalItems || 0)
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit, keyword, id_degree, id_faculty])

    useEffect(() => {
        handleGetData()
    }, [handleGetData])

    const getDegree = async () => {
        await degreeApi.getDegree().then((res) => {
            if (res.status < 300) {
                setDegree(res.data?.data || []);
            }
        }).catch((err) => {
            console.log(err)
        })
    }
    const getFaculty = async () => {
        await facultyApi.getFaculty().then((res) => {
            if (res.status < 300) {
                setFaculty(res.data?.data || []);
            }
        }).catch((err) => {
            console.log(err)
        })
    }

    useEffect(() => {
        getDegree()
        getFaculty()
    }, [])
    return (
        <Box sx={{ display: 'flex', flexDirection: "column", gap: '10px' }}>
            <StateComponents
                otherProps={{ spacing: 2 }}
                typeProps={[
                    {
                        seq: 1,
                        type: "TEXT_FIELD",
                        gridProps: {
                            xs: 12,
                            md: 4
                        },
                        fieldProps: {
                            placeholder: t("PERIOD_EXAMINATION_SEARCH"),
                            onChange: (e) => debouncedApiCall({ setItem: setKeyword, searchItem: e.target.value })
                        }
                    },

                    {
                        seq: 2,
                        type: "SELECT",
                        gridProps: {
                            xs: 12,
                            md: 3
                        },
                        fieldProps: {
                            labelId: "ss",
                            heading: "",
                            onChange: (e) => {
                                // handleChange('form_type', index, e.target.value);
                                set_id_degree(e.target.value)
                            },
                            options: [{
                                label: t('PERIOD_EXAMINATION_ALL_LEVELS'),
                                value: "ALL",
                            }, ...degree?.map((item: any) => {
                                return {
                                    label: i18n.language === "en" ? (item?.degree_name_eng || item?.degree_name) : item?.degree_name,
                                    value: item?.id_degree,
                                }
                            })],
                            selectId: "",
                            value: id_degree || '',
                        }
                    },
                    {
                        seq: 3,
                        type: "SELECT",
                        gridProps: {
                            xs: 12,
                            md: 3
                        },
                        fieldProps: {
                            labelId: "ss",
                            heading: "",
                            onChange: (e) => {
                                // handleChange('form_type', index, e.target.value);
                                set_id_faculty(e.target.value)
                            },
                            options: [{
                                label: t('PERIOD_EXAMINATION_ALL_COURSES'),
                                value: "ALL",
                            }, ...faculty?.map((item: any) => {
                                return {
                                    label: i18n.language === "en" ? (item?.faculty_name_eng || item?.faculty_name) : item?.faculty_name,
                                    value: item?.id_faculty,
                                }
                            })],
                            selectId: "",
                            value: id_faculty || '',
                        }
                    },


                ]}
            />
            <TableCustom
                tableMinWidth={1440}
                tableFixedWidth
                customScroll
                page={page}
                pageLimit={pageLimit}
                sortBy={sortBy}
                sortType={sortType}
                headCells={headCells}
                rowCount={totalItems}
                rowsData={item?.map((data: any, i: any) => {
                    return renderData(data, i)
                })}
                onSort={handleRequestSort}
                setPageLimit={(value: number) => setPageLimit(value)}
                setPage={(value: number) => setPage(value)}
            />
        </Box>
    )
}